export default "__VITE_ASSET__feac5420__"